var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuumSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1566_14975)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 24C24.4183 24 28 20.4183 28 16C28 11.5817 24.4183 8 20 8C15.5817 8 12 11.5817 12 16C12 20.4183 15.5817 24 20 24Z",
    fill: "#003680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7 28.02C15.24 27.82 4 30.54 4 36V40H23.08C18.14 34.48 20.62 28.22 20.7 28.02Z",
    fill: "#003680"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.86 36.04C39.58 34.86 40 33.48 40 32C40 27.58 36.42 24 32 24C27.58 24 24 27.58 24 32C24 36.42 27.58 40 32 40C33.48 40 34.86 39.56 36.04 38.86L41.18 44L44 41.18L38.86 36.04ZM32 36C29.8 36 28 34.2 28 32C28 29.8 29.8 28 32 28C34.2 28 36 29.8 36 32C36 34.2 34.2 36 32 36Z",
    fill: "#003680"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1566_14975"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuumSearch);
export default __webpack_public_path__ + "static/media/ruum-search.4fabb687147cac659292252bc90d7ef9.svg";
export { ForwardRef as ReactComponent };